<template>
    <div class="quickpay-esign-card">
        <div class="quickpay-esign-card__header">
            <h4 class="quickpay-esign-card__title typographies-heading-h4">
                {{ translations.title }}
            </h4>
            <img src="/ressources/logged/img/illustrations/esign-logo.svg" />
        </div>
        <p class="quickpay-esign-card__description typographies-paragraph-small-regular">
            {{ translations.description }}
        </p>
        <CompassButton
            :label="translations.btnLabel"
            class="quickpay-esign-card__button"
            @click="openSignatureLink"
        />
        <img
            :src="`/ressources/logged/img/illustrations/${normalizedProvider}.svg`"
            class="quickpay-esign-card__img-provider"
        />
    </div>
</template>

<script>
export default {
    props: {
        providerEsign: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            translations: {
                title: this.$t.__('common.labels.signature_electronic'),
                description: this.$t.__('quickpay.QuickpayEsignCard.description', {
                    labelButton: this.$t.__('common.labels.sign_document'),
                }),
                btnLabel: this.$t.__('common.labels.sign_document'),
            },
        };
    },
    computed: {
        normalizedProvider() {
            // Normalize provider: "sellsy.yousign.v3", "sellsy", "yousign.v2" -> "yousign"
            if (['sellsy.yousign.v3', 'sellsy', 'yousign.v2'].includes(this.providerEsign)) {
                return 'yousign';
            }
            return this.providerEsign; // "docusign" or any other value
        },
    },
    methods: {
        openSignatureLink() {
            this.$emit('sign');
        },
    },
};
</script>

<style lang="scss" scoped>
.quickpay-esign-card {
    display: flex;
    flex-direction: column;
    padding: var(--spacing-3) var(--spacing-4);
    background: var(--colors-common-background-default);
    border-radius: var(--spacing-1);
    box-shadow: var(--elevation-1);

    &__header {
        display: flex;
        gap: var(--spacing-3);
        margin: 0 0 var(--spacing-1);
        align-items: center;
    }
    &__title {
        color: var(--colors-common-text-standard-default);
        margin: 0;
    }
    &__description {
        color: var(--colors-common-text-subtle-default);
        margin: 0 0 var(--spacing-3);
    }
    &__button {
        margin: 0 0 var(--spacing-3);
    }
    &__img-provider {
        width: 60px;
        align-self: center;
    }
}
</style>
